module.exports = __webpack_public_path__ + "static/media/dhritiman.0060913d.png";